import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { LayoutDashboard, Users, LogOut, Sun } from "lucide-react";

const TABS = [
  { id: "today", label: "Today", icon: Sun, path: "/dashboard", disabled: true },
  { id: "dashboard", label: "Dashboard", icon: LayoutDashboard, path: "/dashboard" },
  { id: "prospects", label: "Prospects", icon: Users, path: "/prospects" },
];

export default function Navigation() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();

  return (
    <header className="sticky top-0 z-40 border-b border-white/8 bg-[#071426]/80 backdrop-blur-xl">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-4">
        <div className="flex items-center gap-6">
          <Logo />
          <nav className="hidden md:flex items-center gap-1">
            {TABS.map((t) => {
              const active = location.pathname === t.path && !t.disabled;
              const Icon = t.icon;
              return (
                <button
                  key={t.id}
                  data-testid={`nav-${t.id}-tab`}
                  disabled={t.disabled}
                  onClick={() => !t.disabled && navigate(t.path)}
                  className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                    active
                      ? "gos-gradient text-white"
                      : t.disabled
                      ? "text-slate-600 cursor-not-allowed"
                      : "text-slate-400 hover:text-white hover:bg-white/5"
                  }`}
                >
                  <Icon className="w-4 h-4" />
                  {t.label}
                </button>
              );
            })}
          </nav>
        </div>

        <div className="flex items-center gap-3">
          <div className="hidden sm:flex items-center gap-2 px-3 py-1.5 rounded-full bg-emerald-500/10 border border-emerald-500/20">
            <span className="w-2 h-2 rounded-full bg-emerald-400 beacon" />
            <span className="text-[10px] font-mono-g uppercase tracking-widest text-emerald-300 font-semibold">Online</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-full gos-gradient flex items-center justify-center text-white text-xs font-bold">
              {(user?.name || user?.email || "?").charAt(0).toUpperCase()}
            </div>
            <div className="hidden lg:block leading-tight">
              <div className="text-xs font-semibold text-white">{user?.name || "User"}</div>
              <div className="text-[10px] text-slate-500">{user?.email}</div>
            </div>
          </div>
          <button
            data-testid="logout-btn"
            onClick={logout}
            className="p-2 rounded-lg text-slate-400 hover:text-white hover:bg-white/5 transition-colors"
            title="Log out"
          >
            <LogOut className="w-4 h-4" />
          </button>
        </div>
      </div>
    </header>
  );
}
